import { rei, selosApi  } from "@/services/api"

class SelosService {
  static storeSelo (data) {
    return rei.post(`selo`, data, { timeout: 10000 }).then(res => res.data)
  }

  static retificarSelo (idSelo) {
    return rei.post(`retificar-selo-tj`, { selo_id: idSelo }, { timeout: 10000 }).then(res => res.data)
  }

  static cancelarSelo (idSelo, numOrdemJudicial = null) {
    const payload = {
      selo_id: idSelo
    }

    if (numOrdemJudicial) {
      payload.num_ordem_judicial = numOrdemJudicial
    }

    return rei.post(`cancelar-selo-tj`, payload, { timeout: 10000 }).then(res => res.data)
  }

  static excluirSelo (idSelo) {
    return rei.post(`excluir-selo-tj`, { selo_id: idSelo }, { timeout: 10000 }).then(res => res.data)
  }
  // Exclui selo no banco de dados
  static delete (idSelo) {
    return rei.delete(`selo/${idSelo}`).then(res => res.data)
  }

  static showSelo (idSelo) {
    return rei.post(`selo/${ idSelo }`, {}, { timeout: 10000 }).then(res => res.data)
  }

  static getSelo (params = null) {
    if (!params) {
      return rei.get('selo', { timeout: 10000 }).then((res) => res.data)
    }

    let query = []
    query.push(params.perPage ? 'perPage=' + params.perPage : '')
    query.push(params.page ? '&page=' + params.page : '')
    query.push(params.registro_id ? '&registroId=' + params.registro_id : '')

    return rei.get(`selo?${query.join('')}`, { timeout: 10000 }).then(res => res.data)
  }

  static getSeloVinculadosByRegistroId (params = null) {
    if (!params || !params.registro_id) return

    let query = []
    query.push(params.registro_id ? 'registroId=' + params.registro_id : '')

    return rei.get(`selos-vinculados-by-registro-id?${query.join('')}`, { timeout: 60000 }).then((res) => res.data)
  }

  static getSelosRegistro (params = null) {
    if (!params || !params.registro_id || !params.num_selo_vinculador) return

    let query = []
    query.push(params.registro_id ? 'registroId=' + params.registro_id : '')
    query.push(params.num_selo_vinculador ? '&numSeloVinculador=' + params.num_selo_vinculador : '')

    return rei.get(`selos-registro?${query.join('')}`, { timeout: 60000 }).then((res) => res.data)
  }

  static vincularSelos (params = null) {
    if (!params || !params.numSeloVinculador || !params.vinculacoes || typeof params.realizarEnvioVinculacaoTJ !== 'boolean') return

    const data = {
      numSeloVinculador: params.numSeloVinculador,
      vinculacoes: params.vinculacoes,
      realizarEnvioVinculacaoTJ: params.realizarEnvioVinculacaoTJ
    }

    data.dataVinculacao = params.dataVinculacao

    return rei.post('vincular-selo-tj', data, { timeout: 60000 }).then(res => res.data)
  }

  static getSeloVinculadorDetalhado (params = null) {
    if (!params || !params.numSeloVinculador || !params.dataVinculacao) return

    let query = []
    query.push(params.numSeloVinculador ? 'numSeloVinculador=' + params.numSeloVinculador : '')
    query.push(params.dataVinculacao ? '&dataVinculacao=' + params.dataVinculacao : '')

    return rei.get(`selo-vinculador-detalhado?${query.join('')}`, { timeout: 60000 }).then((res) => res.data)
  }

  static enviarVinculacoesPendentesTJ (params = null) {
    if (!params || !params.numSeloVinculador || !params.dataVinculacao) return

    const data = {
      numSeloVinculador: params.numSeloVinculador,
      dataVinculacao: params.dataVinculacao
    }

    return rei.post('enviar-vinculacoes-pendentes-tj', data, { timeout: 60000 }).then(res => res.data)
  }

  static excluirVinculacoes (params = null) {
    if (!params || !params.vinculacoesIds.length) return

    const data = {
      vinculacoesIds: params.vinculacoesIds
    }

    return rei.delete('excluir-vinculacoes', { params: { ...data } }, { timeout: 60000 }).then(res => res.data)
  }

  static getSelosCancelados (params) {
    return rei.post('selos-cancelados', params, { timeout: 10000}).then(res => res.data)
  }

  static getSelosVinculadores (params) {
    const query = []

    Object.keys(params).forEach(param => {
      if (!params[param]) return

      if (param === 'tiposRegistros') {
        params['tiposRegistros'].forEach((tipoRegistro, index) => {
          query.push(`${query.length ? '&' : ''}tiposRegistros[${index}]=${tipoRegistro}`)
        })
      } else {
        query.push(`${query.length ? '&' : ''}${param}=${params[param]}`)
      }
    })

    return rei.get(`gerenciador-tarefas/selos-vinculadores?${query.join('')}`, { timeout: 60000 }).then((res) => res.data)
  }

  static async gerarSeloVinculado (data) {
    return rei.post(`selo-vinculado`, data, {timeout: 10000}).then(res => res.data)
  }

  static getSelosNaoEnviados (params = null) {
    let query = []
    
    query.push(params.perPage ? 'perPage=' + params.perPage : '')
    query.push(params.page ? '&page=' + params.page : '')

    if (params.status_selos) {
      query.push(`status_selos=${params.status_selos}`)
    }
    
    return rei.get(`selos-nao-enviados?${query.join('')}`, { timeout: 10000 }).then(res => res.data)
  }

  static enviarNumeroSeloApi (numSelo) {
    return selosApi.post(`/selos/${numSelo}/enviar`).then(res => res.data)
  }
}

export default SelosService
